import React from 'react'
import '../../styles/workhero.css'

const Workhero = () => {
  return (
    <div className='container how-work-container'>
        <div className="work-hero-left">
<h1 className='how-work-heading-hero'>Target the <br />
right survey audience</h1>
<div className="line-div"></div>
<div className="solution">
    <p className='hero-how-work-title'>Our Solutions</p>
    <p className='solution-hero-para'>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>
</div>
        </div>
        <div className="how-work-right-hero">
<img src="/images/how.png" alt="" />
        </div>
    </div>
  )
}

export default Workhero;